// Remove the no-js class from html element
// @TODO: Add no-js styles for when js is unavailable
export default function init() {
  document.documentElement.classList.remove('no-js');
}
